import Vue from 'vue'
import VueI18n from 'vue-i18n'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import en from 'vuetify/lib/locale/en'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import es from 'vuetify/lib/locale/es'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import fr from 'vuetify/lib/locale/fr'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import de from 'vuetify/lib/locale/de'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import it from 'vuetify/lib/locale/it'

Vue.use(VueI18n)

// Supported languages constant
const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'de', 'it'] as const

// Language detection function
const detectLanguage = (): string => {
  // Check localStorage first
  const stored = localStorage.getItem('planbook-locale')
  if (stored) return stored

  // Check browser language
  const browserLang = navigator.language.split('-')[0]

  return SUPPORTED_LANGUAGES.includes(browserLang as any) ? browserLang : 'en'
}

// Check URL query parameters for locale
const getUrlLocale = (): string | null => {
  if (typeof window === 'undefined') return null

  const urlParams = new URLSearchParams(window.location.search)
  const locale = urlParams.get('locale')

  return locale && SUPPORTED_LANGUAGES.includes(locale as any) ? locale : null
}

// Get the initial locale - prioritize URL param, then localStorage, then env var
const getInitialLocale = (): string => {
  // First check URL query parameter
  const urlLocale = getUrlLocale()
  if (urlLocale) {
    localStorage.setItem('planbook-locale', urlLocale)
    return urlLocale
  }

  // Then check if there's a stored preference
  const stored = localStorage.getItem('planbook-locale')
  if (stored) return stored

  // Then check environment variable
  if (process.env.VUE_APP_I18N_LOCALE) return process.env.VUE_APP_I18N_LOCALE

  // Finally detect from browser or default to English
  return detectLanguage()
}

const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en
  },
  es: {
    ...require('@/locales/es.json'),
    $vuetify: es
  },
  fr: {
    ...require('@/locales/fr.json'),
    $vuetify: fr
  },
  de: {
    ...require('@/locales/de.json'),
    $vuetify: de
  },
  it: {
    ...require('@/locales/it.json'),
    $vuetify: it
  }
}

const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages
})

// Store the detected language in localStorage if not already present
const detectedLocale = getInitialLocale()
if (!localStorage.getItem('planbook-locale')) {
  localStorage.setItem('planbook-locale', detectedLocale)
}

// Helper function to update HTML lang attribute
export const updateHtmlLang = (locale: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale
  }
}

// Set initial HTML lang attribute
updateHtmlLang(i18n.locale)

export default i18n
